import { Component } from '@angular/core';
import { LeftSplitviewComponent } from '../../components/left-splitview/left-splitview.component';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { UnauthFooterComponent } from '../../components/unauth-footer/unauth-footer.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss'],
    imports: [
        LeftSplitviewComponent,
        RouterLinkActive,
        RouterLink,
        UnauthFooterComponent,
        TranslateModule,
    ],
})
export class PasswordResetComponent {
    constructor() {}
}
